import React from "react";

import { Outlet } from "react-router-dom";

import Header from "./Header";
import "./Layout.css";
import Sidebar from "./Sidebar";

const Layout: React.FC = () => {
  return (
    <div className="layout">
      <Header />
      <div className="layout-content">
        <Sidebar />
        <main className="main-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default Layout;
